module.exports = __webpack_public_path__ + "img/notif_green.2806a661.svg";